import { Component, computed, inject, signal, Signal } from '@angular/core';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { Icon } from '../../icon/icon';
import { UnitType } from '../../../models/unit.model';
import { DistancePipe } from '../../../pipes/distance-pipe';
import { ApiService } from '../../../services/api-service';
import { TrainingModeType } from '../../../models/training-mode.model';

@Component({
  selector: 'li[app-distance-data-item-block]',
  imports: [Icon, DataItemTemplate, DistancePipe],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      <app-icon [size]="iconSize()" class="icon" icon="distance" />
      <p class="name">{{ value() | distance: unit() : 'unit' }}</p>
      <p class="value">{{ displayedValue() }}</p>
    </app-data-item-template>
  `,
  styleUrl: './distance-data-item-block.scss',
})
export class DistanceDataBlockItem extends DataItemTemplate {
  apiService: ApiService = inject(ApiService);
  private distancePipe: DistancePipe = new DistancePipe();
  value: Signal<number> = computed(() => this.webSocketService.broadcastData()?.data.distance || 0);
  unit: Signal<UnitType> = signal((localStorage.getItem('unit') as UnitType) || 'metric');
  displayedValue: Signal<string> = computed(() =>
    this.distancePipe.transform(this.value(), this.unit(), 'value', 2).replace(/\.00$/, ''),
  );
  objectif: Signal<number | undefined> = computed<number | undefined>(
    () => this.apiService.scenicInformation()?.duration,
  );
  trainingMode: Signal<TrainingModeType> = computed(
    () => this.webSocketService.contentInformation()?.trainingMode || 'originalSpeed',
  );
}
